module.exports = __webpack_public_path__ + "static/media/mobile-app-apple-store-image.2c7866b0.png";